import {
  SendRequest,
  Image,
  imageSize,
  CompanyIntegrationService,
  createIntegrationData,
  addParamsToUrl,
} from "@/imports-files/pages/clients/activities/client-integrations";

export class CompanyIntegrationAction extends SendRequest {
  companyIntegrationService = new CompanyIntegrationService();
  constructor() {
    super();
    this.applyFilter = this.applyFilter.bind(this);
    this.applyClientFilter = this.applyClientFilter.bind(this);
  }

  async applyFilter(
    values,
    setEnableItems,
    set_disable_integrations_array,
    router
  ) {
    try {
      const selectedArray = Object.keys(values).filter((key) => values[key]);
      const queryParams =
        selectedArray.length > 0
          ? {
              integration_category:
                selectedArray.length > 1 ? selectedArray : selectedArray[0],
            }
          : {};
      addParamsToUrl(queryParams, router);
      const result = await this.companyIntegrationService.applyFilter(values);
      const enableItems = await setIntegrationData(result.data?.enabled);
      const disableItems = await setDisabledIntegrationData(result.data?.disabled);
      setEnableItems(enableItems);
      set_disable_integrations_array(disableItems);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
  }
  async applyClientFilter(
    values,
    updateIntegrationRows,
    client_id,
    addIntegrationData,
    router
  ) {
    try {
      const selectedArray = Object.keys(values).filter((key) => values[key]);
      const queryParams =
        selectedArray.length > 0
          ? {
              integration_category:
                selectedArray.length > 1 ? selectedArray : selectedArray[0],
            }
          : {};
      addParamsToUrl(queryParams, router);

      const result = await this.companyIntegrationService.applyClientFilter(
        values,
        client_id
      );
      const data = addIntegrationData(
        result.data?.client_integrations,
        result.data.step
      );
      updateIntegrationRows(data);
    } catch (error) {
      console.error("Error applying filter:", error);
    }
  }
}

export async function setIntegrationData(data) {
  return (
    data?.map((x, index) => {
      const logo_url = `/images/pages/integration/${x.integration.display_name
        .toLowerCase()
        .replace(/\s/g, "_")}.png`;

      return createIntegrationData(
        index,
        x.id,
        x.integration.id,
        x.integration.slug,
        x.integration.display_name,
        x.integration.description,
        x.integration.user_enabled,
        x.integration.is_linkable,
        x.integration.idibu_data_exists,
        x.integration.idibu_data,
        <Image
          src={logo_url}
          alt=""
          width={
            imageSize(
              x.integration.display_name.toLowerCase().replace(/\s/g, "_")
            ).width
          }
          height={
            imageSize(
              x.integration.display_name.toLowerCase().replace(/\s/g, "_")
            ).height
          }
        />,
        x.accessible,
        x.connected,
        x.integration.redirect_url,
        x.integration_limit,
      );
    }) || []
  );
}

export async function setDisabledIntegrationData(data) {
  return data?.map((x, index) => {
    let logo_url = `/images/pages/integration/${x.display_name
      .toLowerCase()
      .replace(/\s/g, "_")}.png`;
    return (
      createIntegrationData(
        index,
        null,
        x.id,
        x.slug,
        x.display_name,
        x.description,
        x.user_enabled,
        x.is_linkable,
        <Image
          src={logo_url}
          alt=""
          width={
            imageSize(x.display_name.toLowerCase().replace(/\s/g, "_")).width
          }
          height={
            imageSize(x.display_name.toLowerCase().replace(/\s/g, "_")).height
          }
        ></Image>,
        false,
        false,
        "",
        "NA"
      ) || []
    );
  });
}
